'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var h = require('react').createElement;
var Box = require('./Box');

var _require = require('./util'),
    idx = _require.idx,
    radius = _require.radius;

var config = require('./config');

var Border = function Border(_ref, context) {
  var color = _ref.color,
      top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left,
      rounded = _ref.rounded,
      props = _objectWithoutProperties(_ref, ['color', 'top', 'right', 'bottom', 'left', 'rounded']);

  var all = !top && !right && !bottom && !left;
  var r = idx(['axs', 'radius'], context) || config.radius;

  return h(Box, _extends({}, props, {
    css: _extends({}, props.css, {
      borderStyle: 'solid',
      borderColor: color,
      borderTopWidth: all || top ? 1 : 0,
      borderRightWidth: all || right ? 1 : 0,
      borderBottomWidth: all || bottom ? 1 : 0,
      borderLeftWidth: all || left ? 1 : 0,
      borderRadius: radius(r)(rounded)
    })
  }));
};

module.exports = Border;


//////////////////
// WEBPACK FOOTER
// ./~/axs/dist/Border.js
// module id = 98
// module chunks = 0